export const FIELD_NAME = {
  PROMO_CODE: 'promotionCode',
  PASSWORD: 'password',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  EMAIL: 'email',
  TERMS_POLICY_AGREED: 'term_and_policy__agreed',
};

export default FIELD_NAME;
